import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";


const firebaseConfig = {
  apiKey: "AIzaSyD25jQOoksnnWTGVs005Cpnr_afKLRJxrY",
  authDomain: "hogar-cariari.firebaseapp.com",
  projectId: "hogar-cariari",
  storageBucket: "hogar-cariari.appspot.com",
  messagingSenderId: "431809990743",
  appId: "1:431809990743:web:ca17b5d6d28b6b8f5a5312"
};

const app = initializeApp(firebaseConfig);


export const db = getFirestore(app);

export const auth = getAuth();

export default app;



